<div class="toolbox-container dmg-user-box">
  <div class="toolbox-heading">
    <div class="toolbox-heading-icon dmg-user-avatar">
      <i class="fas fa-user"></i>
    </div>
    <div class="toolbox-heading-text">
      <span class="toolbox-title">{{ currentUserName || 'Utente collegato' }}</span>
      <small class="toolbox-subtitle dmg-user-code">{{ currentUserCode || '-' }}</small>
    </div>
  </div>
  <div class="toolbox-divider"></div>
  <div class="toolbox-buttons">

    <!-- Gestione danni (pagina di ingresso: resoconto e funzionalità) -->
    <a class="toolbox-btn toolbox-btn--blue"
       routerLink="/damage-management" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
       title="Gestione danni">
      <i class="fas fa-house-damage"></i>
    </a>

    <!-- Panoramica danni (pratiche e colli, pagina principale) -->
    <a class="toolbox-btn toolbox-btn--blue"
       routerLink="/damage-overview" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
       title="Panoramica danni">
      <i class="fas fa-folder-open"></i>
    </a>

    <!-- Panoramica clienti -->
    <a class="toolbox-btn toolbox-btn--blue"
       routerLink="/damages-client-overview" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
       title="Panoramica clienti">
      <i class="fas fa-users"></i>
    </a>

    <!-- Panoramica dealer -->
    <a class="toolbox-btn toolbox-btn--blue"
       routerLink="/damages-dealer-overview" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
       title="Panoramica dealer">
      <i class="fas fa-store"></i>
    </a>

    <!-- Assegnate a me, con badge delle pratiche aperte in carico -->
    <a class="toolbox-btn toolbox-btn--blue dmg-assigned-btn"
       routerLink="/damage-overview/assigned" routerLinkActive="active"
       [title]="assignedTitle">
      <i class="fas fa-user-check"></i>
      <span class="dmg-assigned-badge" *ngIf="assignedCount != null" [class.dmg-assigned-badge--empty]="assignedCount === 0">
        {{ assignedCount > 99 ? '99+' : assignedCount }}
      </span>
    </a>

  </div>
</div>
